<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>登录中</h1>
      <p class="status-text">{{ statusText }}</p>
      <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
      <button v-if="errorMsg" type="button" class="back-link" @click="retryLogin">重新登录</button>
    </div>
  </div>
</template>

<script>
import { exchangeWeChatOAuth } from '@/api/portal/auth'
import { setToken, setMember, getToken } from '@/utils/auth'
import { openLogin, emitLoginSuccess } from '@/utils/loginModal'

export default {
  name: 'WeChatCallbackView',
  data() {
    return {
      statusText: '正在完成登录...',
      errorMsg: ''
    }
  },
  mounted() {
    if (getToken()) {
      this.goNext()
      return
    }
    const code = this.$route.query.code
    if (!code) {
      this.errorMsg = '登录凭证缺失，请重新登录'
      this.statusText = '登录失败'
      return
    }
    exchangeWeChatOAuth(code)
      .then(res => {
        setToken(res.token)
        setMember(res.member)
        emitLoginSuccess()
        this.goNext()
      })
      .catch(err => {
        this.errorMsg = err.message || '登录失败'
        this.statusText = '登录失败'
      })
  },
  methods: {
    goNext() {
      const redirect = this.$route.query.redirect
      const path = typeof redirect === 'string' && redirect.startsWith('/') ? redirect : '/workbench'
      this.$router.replace(path)
    },
    retryLogin() {
      const redirect = this.$route.query.redirect
      const path = typeof redirect === 'string' && redirect.startsWith('/') ? redirect : '/workbench'
      this.$router.replace(path).then(() => {
        this.$nextTick(() => openLogin(path))
      })
    }
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%);
}

.auth-card {
  width: 100%;
  max-width: 420px;
  padding: 36px 32px;
  border-radius: 16px;
  background: #fff;
  box-shadow: var(--shadow-card);
  text-align: center;
}

.auth-card h1 {
  margin: 0 0 12px;
  font-size: 24px;
}

.status-text {
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
}

.error-msg {
  margin: 16px 0 0;
  color: #ef4444;
  font-size: 14px;
}

.back-link {
  display: inline-block;
  margin-top: 16px;
  color: var(--primary);
  font-size: 14px;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
